<template>
  <BaseSysLog />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
